import { Typography, Link } from "@mui/material";

const NewsDetailComponent: React.FC<{ news }> = ({ news }) => {
  return (
    <>
      <Typography
        variant="h6"
        color="primary"
        sx={{ textAlign: "center", fontWeight: "bold" }}
      >
        Details
      </Typography>
      {news.provider && (
        <Typography variant="body1" color="text.secondary">
          <strong>Source:</strong> {news.provider}
        </Typography>
      )}
      {news.hashtag && (
        <Typography variant="body1" color="text.secondary">
          <strong>Hashtag:</strong> {news.hashtag}
        </Typography>
      )}
      {news.time && (
        <Typography variant="body1" color="text.secondary">
          <strong>Date Published:</strong> {news.time}
        </Typography>
      )}
      {news.title && (
        <Typography variant="body1" color="text.secondary">
          <strong>Title:</strong> {news.title}
        </Typography>
      )}
      {news.link && (
        <Typography variant="body1" color="text.secondary">
          <strong>Link:</strong>{" "}
          <Link
            href={news.link}
            color="inherit"
            variant="h6"
            target="_blank"
            fontSize="14px"
          >
            {news.link}
          </Link>
        </Typography>
      )}
      {news.content && (
        <Typography variant="body1" color="text.secondary">
          <strong>Content:</strong> {news.content}
        </Typography>
      )}
      {news.location_name && (
        <Typography variant="body1" color="text.secondary">
          <strong>Location name:</strong> {news.location_name}
        </Typography>
      )}
      {news.latitude && news.longitude && (
        <Typography variant="body1" color="text.secondary">
          <strong>Coordinates:</strong> [{news.longitude}, {news.latitude}]
        </Typography>
      )}
    </>
  );
};

export default NewsDetailComponent;
